export enum SeverityLevelEnum {
  Fatal = 1,
  Severe = 2,
  Mild = 3,
  Moderate = 4,
  NotSevere = 5
}

export const SeverityLevelOptions = [
{ id: 1, label: 'Fatal', conceptId: 399166001 },
{ id: 2, label: 'Severe', conceptId: 24484000 },
{ id: 3, label: 'Mild', conceptId: 255604002 },
{ id: 4, label: 'Moderate', conceptId: 6736007 },
{ id: 5, label: 'Not Severe', conceptId: '451771000124108' }
];
